import React from 'react'
import styled from '@emotion/styled'
import { Button } from 'antd'
import { PageCrumbs } from 'components'
import { colors } from 'style/theme'
import { formatNumberIntl } from 'utils/formatters'

const StyledAccountTop = styled.div({
  display: 'grid',
  gridTemplateColumns: '1fr 140px 192px',
  marginBottom: 20,
  alignItems: 'center'
})

const CurrentCredits = styled.div({
  display: 'flex',
  fontSize: '0.9rem'
})

const CreditsLabel = styled.span({
  fontWeight: 200,
  color: colors.brandTextLight
})

const CreditsValue = styled.span(props => ({
  color: props.credits === 0 ? colors.brandText : props.credits > 0 ? colors.success.color : colors.error.color,
  marginLeft: 4,
  fontWeight: 600
}))

const AccountCreditsTop = ({ accountName, onAddCredits, currentCredits = null }) => {
  return (
    <StyledAccountTop>
      <PageCrumbs
        crumbs={[
          { name: 'Administration', icon: 'bars', path: '/administration/account' },
          { name: accountName },
          { name: 'Credits' }
        ]}
      />
      <CurrentCredits>
        <CreditsLabel>CREDITS</CreditsLabel>
        <CreditsValue credits={currentCredits}>{formatNumberIntl(currentCredits)}</CreditsValue>
      </CurrentCredits>
      <Button type="primary" icon="plus" onClick={onAddCredits}>
        ADD CREDITS
      </Button>
    </StyledAccountTop>
  )
}

export default AccountCreditsTop
